export default __webpack_public_path__ + "static/media/searchEmpty.f61aa720.svg";